const COOKIE_NAME = "inora_ph_oauth";
const MAX_AGE_SEC = 120;

export type OAuthAnalyticsPayload = {
  provider: "google" | "github";
  isNew: boolean;
};

export function setOAuthAnalyticsCookie(
  res: { cookies: { set: (name: string, value: string, opts: Record<string, unknown>) => void } },
  payload: OAuthAnalyticsPayload,
): void {
  res.cookies.set(COOKIE_NAME, `${payload.provider}:${payload.isNew ? "1" : "0"}`, {
    httpOnly: false,
    secure: process.env.NODE_ENV === "production",
    sameSite: "lax",
    path: "/",
    maxAge: MAX_AGE_SEC,
  });
}

export function consumeOAuthAnalyticsCookie(): OAuthAnalyticsPayload | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${COOKIE_NAME}=`));
  if (!match) return null;

  const raw = match.slice(COOKIE_NAME.length + 1);
  const [provider, isNewFlag] = raw.split(":");
  if (provider !== "google" && provider !== "github") return null;

  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;

  return {
    provider,
    isNew: isNewFlag === "1",
  };
}
